import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Params } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { AncDataService } from 'src/app/services/ANC/anc-data.service';
import { DeviceService } from 'src/app/services/devices/device.service';

@Component({
    selector: 'app-anc-seasons',
    imports: [CommonModule, FormsModule, TranslateModule],
    templateUrl: './anc-seasons.component.html'
})
export class AncSeasonsComponent implements OnInit {


  @Input() allSettings: boolean = false;
  device : string = '';
  dataSeason: any = null;
  winter: any = null;
  summer: any = null;
  winterRaw: any = null;
  summerRaw: any = null;
  changesMade: boolean = false;
  error : string = '';
  successMessage : boolean = false;
  orignalDataSeason: any = null;


  constructor(private _aRoute: ActivatedRoute, private _deviceService: DeviceService, private _ancDataService: AncDataService) { }


  ngOnInit(): void {

    this._aRoute.parent?.parent?.params
      .subscribe((params: Params) => this.device = params['serial']);

       this._deviceService.getModuleInfo(this.device, "seasons").subscribe(data=>{
        this.winterRaw = JSON.parse(data.cfg.winter);
        this.summerRaw = JSON.parse(data.cfg.summer);
         this.dataSeason = this._ancDataService.formatSeasonData(data.cfg);
         this.orignalDataSeason = JSON.parse(JSON.stringify(this.dataSeason));
         console.log('Data seasons formateado', this.dataSeason);
         this.winter = this.dataSeason.winter
         this.summer = this.dataSeason.summer
        })
  }


save(){

  // if (!this.dataSeason.enable){
  //   this.winterRaw[8] = 0;
  //   this.winterRaw[9] = 0;
  //   this.summerRaw[8] = 0;
  //   this.summerRaw[9] = 0;
  // }else{
  //   this.winterRaw[8] = 1;
  //   this.summerRaw[8] = 1;
  //   this.winterRaw[9] = 1;
  //   this.summerRaw[9] = 1;
  // }

  const body = {
    enable: this.dataSeason.enable ? 1 : 0,
    // winter: this.winterRaw,
    // summer: this.summerRaw
  }

  this._deviceService.setModuleCfg(this.device, body, "seasons").subscribe(data => {
    this.successMessage = true;
    console.log('data seasons ', data);
    setTimeout(() => {
      this.successMessage = false;
    }, 3000);
  })


}

restore(){
  this.dataSeason = JSON.parse(JSON.stringify(this.orignalDataSeason));
  this.winter = this.dataSeason?.winter ?? null;
  this.summer = this.dataSeason?.summer ?? null;

  this.changesMade = false;
}

}
